// AchievementsSection.js
import { motion } from "framer-motion";
import React from "react";
import theme from "../theme/theme1";
 
const AchievementCard = ({ title, description, image }) => {
  return (
    <motion.div
      className="bg-[#1a3a5b] text-white p-6 shadow-lg transition-all transform hover:scale-105 hover:rotate-1 w-full sm:w-80 md:w-72 lg:w-1/4 rounded-lg"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      style={{ fontFamily: theme.achievementsSection.fontFamily }} // Applied font family from theme
    >
      <div className="flex justify-center items-center mb-4 bg-gray-200 rounded-lg overflow-hidden h-40 w-full">
        {image ? (
          <img
            src={image}
            alt={title}
            className="object-cover w-full h-full"
            style={{ boxShadow: theme.achievementsSection.imageShadow }} // Applied image shadow from theme
          />
        ) : (
          <span className="text-gray-500">No Image Available</span>
        )}
      </div>
      <h3
        className="text-xl font-semibold text-[#b5a262] mb-2 text-center"
        style={{ color: theme.achievementsSection.headingTextColor }} // Applied heading text color from theme
      >
        {title}
      </h3>
      <p className="text-gray-300 leading-relaxed text-justify tracking-normal overflow-visible">
        {description}
      </p>
    </motion.div>
  );
};

const AchievementsSection = () => {
  const achievements = [
    {
      title: "Swimmer of the Year: Aditi Sharma",
      description:
        "Aditi Sharma, an exceptional young athlete, triumphed in the National Swimming Championship, where she won multiple gold medals. Her dedication, discipline, and rigorous training have made her a rising star in the swimming world. This award recognizes her hard work and commitment to her sport.",
      image: "https://app.fide.com/upload/23066/f99687dd719c4e8bc6a39e946c3d9ef7.jpg",
    },
    {
      title: "Manu Bhaker's Achievement",
      description:
        "Manu Bhaker, the celebrated shooter, was felicitated for her remarkable achievements at a young age. Her victories in various international shooting championships have made the country proud. This achievement reflects her unwavering focus and passion for excellence in shooting.",
      image: "https://images.mykhel.com/img/2024/08/manu-bhaker-felicitated-1200-1724154289.jpg",
    },
    {
      title: "Award for Excellence in Sports",
      description:
        "This award is given to individuals who have made exceptional contributions in the field of sports. The recipients of this award have demonstrated resilience, sportsmanship, and a commitment to excellence. Their achievements inspire others to pursue their passions with dedication.",
      image: "https://societyachievers.com/wp-content/uploads/2022/11/1-2.jpg",
    },
  ];

  return (
    <section
      className="py-16 px-6"
      style={{
        backgroundColor: theme.achievementsSection.backgroundColor, // Applied background color from theme
        color: theme.achievementsSection.textColor, // Applied text color from theme
        fontFamily: theme.achievementsSection.fontFamily, // Applied font family from theme
      }}
    >
      <motion.div
        className="text-center mb-10"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h2
          className="text-4xl font-extrabold"
          style={{ color: theme.achievementsSection.headingTextColor }} // Applied heading text color from theme
        >
          Our Achievements
        </h2>
        <p className="mt-4 text-lg text-gray-300 leading-relaxed">
          We are proud of our accomplishments in various fields. Here are some highlights.
        </p>
      </motion.div>

      <div className="flex flex-wrap justify-center gap-8">
        {achievements.map((achievement, index) => (
          <AchievementCard
            key={index}
            title={achievement.title}
            description={achievement.description}
            image={achievement.image}
          />
        ))}
      </div>
    </section>
  );
};

export default AchievementsSection;
